import React from 'react';
import { PropTypes } from 'prop-types';

import DuplicateAccountsPanel from './DuplicateAccountsPanel';

const UsersInfoPopup = ({ formInput, handleClick, action }) => (
  <div className="bg-black text-white p-4">
    <DuplicateAccountsPanel userId={formInput && formInput._id} />
    <div className="overflow-auto max-h-96 p-4 bg-gray-900 rounded">
      <pre className="text-xs text-white whitespace-pre-wrap break-words">
        {JSON.stringify(formInput, null, 2)}
      </pre>
    </div>
    <div className="flex justify-end my-2">
      <button
        type="button"
        className="font-americaMonoBold text-xs px-6 py-2 rounded-full border-white border-1 bg-black text-white uppercase ml-7 mt-2 w-110px"
        onClick={() => handleClick(action)}
      >
        Close
      </button>
    </div>
  </div>
);

UsersInfoPopup.propTypes = {
  formInput: PropTypes.shape({ _id: PropTypes.string }),
  handleClick: PropTypes.func.isRequired,
  action: PropTypes.string,
};

UsersInfoPopup.defaultProps = {
  formInput: null,
  action: '',
};

export default UsersInfoPopup;
